module.exports = __webpack_public_path__ + "static/media/36d.c3c84b52.jpg";